// removed by extract-text-webpack-plugin
module.exports = {"vpFileUploadInputContainer":"vpFileUploadInputContainer___afSsV","vpFileUploadInputLabelContainer":"vpFileUploadInputLabelContainer___1ofu2","vpFileUploadInputLabel":"vpFileUploadInputLabel___1EF_J","vpFileUploadArea":"vpFileUploadArea___3xbJk","vpFileTypesLoader":"vpFileTypesLoader___19jn0","vpRequiredLabel":"vpRequiredLabel___23zLt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/FileUploadInput.module.less
// module id = 3837
// module chunks = 33